import React, { useEffect } from 'react';
import { FundResults } from '@Components/FundResults/FundResults';
import { Loader } from '@Components';
import { useRouter } from '@Helpers/useRouter';
import { PathParams } from '@App/paths';
import { useGetFundData, useGetFundProjectUpdates } from '@Hooks/Api';
import { useGetAllFundedProjects } from '@Hooks/Api/useGetAllFundedProjects';

export const FundResultsController = () => {
  const { params } = useRouter();
  const fundId = Number(params[PathParams.FUND_ID]);
  const [getFundData, { loading: isFundDataLoading, data: fundData }] = useGetFundData();
  const [getFundedProjects, { data: fundedProjects, loading: isFundedProjectsLoading }] =
    useGetAllFundedProjects();
  const [getFundProjectUpdates, { paginatedData: updatesPaginatedResponse }] =
    useGetFundProjectUpdates();

  useEffect(() => {
    if (fundId) {
      getFundData(fundId);
      getFundedProjects({ fundId });
      getFundProjectUpdates(fundId);
    }
  }, [fundId, getFundData, getFundedProjects, getFundProjectUpdates]);

  if (isFundDataLoading || isFundedProjectsLoading) {
    return <Loader />;
  }

  return fundData ? (
    <FundResults
      fundId={fundId}
      fundData={fundData}
      fundedProjectsList={fundedProjects?.results || []}
      updatesPaginatedResponse={updatesPaginatedResponse}
    />
  ) : null;
};
